import { Lucide } from "../symbole";

/*
 * Lucide-Symbole des Bearbeiten-Pfads (Paket E-W2) als Inline-Linien (R-F: Lucide; das Bausteinpaket führt keine Symbol-Bibliothek
 * als Abhängigkeit, wie `AnsichtWahl`). Pfade 1:1 aus lucide (table, image, at-sign, list-tree, code-xml, plus, chevron-down,
 * chevron-up, grip-vertical, trash-2, copy-plus, between-horizontal-start/-end, between-vertical-start/-end, panel-top,
 * align-left/-center/-right, align-vertical-justify-start/-center/-end, table-cells-merge, table-cells-split).
 */

export const SymTabelle = () => (
  <Lucide>
    {/* Preline: forms/forms-sub-core-inputs-layouts/forms-cat-text-editors/rich-text-editor-card */}
    <path d="M12 3v18" />
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M3 9h18" />
    <path d="M3 15h18" />
  </Lucide>
);
export const SymBildEinfuegen = () => (
  <Lucide>
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
    <circle cx="9" cy="9" r="2" />
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
  </Lucide>
);
export const SymAt = () => (
  <Lucide>
    <circle cx="12" cy="12" r="4" />
    <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" />
  </Lucide>
);
export const SymVerzeichnis = () => (
  <Lucide>
    <path d="M21 12h-8" />
    <path d="M21 6H8" />
    <path d="M21 18h-8" />
    <path d="M3 6v4c0 1.1.9 2 2 2h3" />
    <path d="M3 10v6c0 1.1.9 2 2 2h3" />
  </Lucide>
);
export const SymCodeBlock = () => (
  <Lucide>
    <path d="m18 16 4-4-4-4" />
    <path d="m6 8-4 4 4 4" />
    <path d="m14.5 4-5 16" />
  </Lucide>
);
export const SymPlus = () => (
  <Lucide>
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </Lucide>
);
export const SymRunter = () => (
  <Lucide>
    <path d="m6 9 6 6 6-6" />
  </Lucide>
);
export const SymHoch = () => (
  <Lucide>
    <path d="m18 15-6-6-6 6" />
  </Lucide>
);
export const SymGriff = () => (
  <Lucide>
    <circle cx="9" cy="12" r="1" />
    <circle cx="9" cy="5" r="1" />
    <circle cx="9" cy="19" r="1" />
    <circle cx="15" cy="12" r="1" />
    <circle cx="15" cy="5" r="1" />
    <circle cx="15" cy="19" r="1" />
  </Lucide>
);
export const SymPapierkorb = () => (
  <Lucide>
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
    <line x1="10" x2="10" y1="11" y2="17" />
    <line x1="14" x2="14" y1="11" y2="17" />
  </Lucide>
);
export const SymDuplizieren = () => (
  <Lucide>
    <line x1="15" x2="15" y1="12" y2="18" />
    <line x1="12" x2="18" y1="15" y2="15" />
    <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
  </Lucide>
);
export const SymSpalteDavor = () => (
  <Lucide>
    <rect width="13" height="7" x="8" y="3" rx="1" />
    <path d="m2 9 3 3-3 3" />
    <rect width="13" height="7" x="8" y="14" rx="1" />
  </Lucide>
);
export const SymSpalteDanach = () => (
  <Lucide>
    <rect width="13" height="7" x="3" y="3" rx="1" />
    <path d="m22 15-3-3 3-3" />
    <rect width="13" height="7" x="3" y="14" rx="1" />
  </Lucide>
);
export const SymZeileDavor = () => (
  <Lucide>
    <rect width="7" height="13" x="3" y="8" rx="1" />
    <path d="m15 2-3 3-3-3" />
    <rect width="7" height="13" x="14" y="8" rx="1" />
  </Lucide>
);
export const SymZeileDanach = () => (
  <Lucide>
    <rect width="7" height="13" x="3" y="3" rx="1" />
    <path d="m9 22 3-3 3 3" />
    <rect width="7" height="13" x="14" y="3" rx="1" />
  </Lucide>
);
export const SymKopfzeile = () => (
  <Lucide>
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M3 9h18" />
  </Lucide>
);
export const SymLinks = () => (
  <Lucide>
    <path d="M15 12H3" />
    <path d="M17 18H3" />
    <path d="M21 6H3" />
  </Lucide>
);
export const SymMitte = () => (
  <Lucide>
    <path d="M17 12H7" />
    <path d="M19 18H5" />
    <path d="M21 6H3" />
  </Lucide>
);
export const SymRechtsAusrichten = () => (
  <Lucide>
    <path d="M21 12H9" />
    <path d="M21 18H7" />
    <path d="M21 6H3" />
  </Lucide>
);
export const SymObenAusrichten = () => (
  <Lucide>
    <rect width="14" height="6" x="5" y="16" rx="2" />
    <rect width="10" height="6" x="7" y="6" rx="2" />
    <path d="M2 2h20" />
  </Lucide>
);
export const SymMitteAusrichten = () => (
  <Lucide>
    <rect width="14" height="6" x="5" y="16" rx="2" />
    <rect width="10" height="6" x="7" y="2" rx="2" />
    <path d="M2 12h20" />
  </Lucide>
);
export const SymUntenAusrichten = () => (
  <Lucide>
    <rect width="14" height="6" x="5" y="12" rx="2" />
    <rect width="10" height="6" x="7" y="2" rx="2" />
    <path d="M2 22h20" />
  </Lucide>
);
export const SymVerbinden = () => (
  <Lucide>
    <path d="M12 21v-6" />
    <path d="M12 9V3" />
    <path d="M3 15h18" />
    <path d="M3 9h18" />
    <rect width="18" height="18" x="3" y="3" rx="2" />
  </Lucide>
);
export const SymTeilen = () => (
  <Lucide>
    <path d="M12 15V9" />
    <path d="M3 15h18" />
    <path d="M3 9h18" />
    <rect width="18" height="18" x="3" y="3" rx="2" />
  </Lucide>
);
